(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('EditClusterDialogController', EditClusterDialogController);

    function EditClusterDialogController(cluster, logger, $q, $uibModalInstance, $translate, dataService) {
        var vm = this;

        vm.cluster = { id: cluster.id, name: cluster.name, clusterType: cluster.clusterType };
        vm.clusterTypes = dataService.getClusterTypes();

        vm.title = vm.cluster.id ? 'edit_cluster' : 'add_cluster';

        vm.cancel = cancel;
        vm.save = save;
        vm.saveDisabled = saveDisabled;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function save(formData) {
            if (!formData.$valid) return $q.reject();

            var data = {
                id: vm.cluster.id,
                name: vm.cluster.name,
                clusterType: vm.cluster.clusterType
            };

            return dataService
                .saveCluster(data)
                .then(id => {
                    logger.success('successfully_saved');
                    data.id = id;
                    $uibModalInstance.close(data);
                });
        }

        function saveDisabled() {
            return !vm.cluster.name;
        }

    }
})();
